export const AUM = "AUM"
export const AUM_RESPONSE = 'AUM_RESPONSE'
export const AUM_RESPONSE_FAIL = 'AUM_RESPONSE_FAIL'

export const GET_INVESTMENT_DISTRIBUTION_STATEMENT = "AGET_INVESTMENT_DISTRIBUTION_STATEMENTUM"
export const GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE = 'GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE'
export const GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL = 'GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL'

export const GET_BALANCE_SHEET = "GET_BALANCE_SHEET";
export const GET_BALANCE_SHEET_RESPONSE = "GET_BALANCE_SHEET_RESPONSE";
export const GET_BALANCE_SHEET_FAILED = "GET_BALANCE_SHEET_FAILED";

export const GET_BROKER_LEDGER = "GET_BROKER_LEDGER";
export const GET_BROKER_LEDGER_RESPONSE = "GET_BROKER_LEDGER_RESPONSE";
export const GET_BROKER_LEDGER_FAILED = "GET_BROKER_LEDGER_FAILED";

export const GET_BANK_BOOK = "GET_BANK_BOOK";
export const GET_BANK_BOOK_RESPONSE = "GET_BANK_BOOK_RESPONSE";
export const GET_BANK_BOOK_FAILED = "GET_BANK_BOOK_FAILED";

export const GET_CLIENT_INFO = "GET_CLIENT_INFO";
export const GET_CLIENT_INFO_RESPONSE = "GET_CLIENT_INFO_RESPONSE";
export const GET_CLIENT_INFO_FAILED = "GET_CLIENT_INFO_FAILED";

export const GET_CUSTODIAN_FEES_LEDGER = "GET_CUSTODIAN_FEES_LEDGER";
export const GET_CUSTODIAN_FEES_LEDGER_RESPONSE = "GET_CUSTODIAN_FEES_LEDGER_RESPONSE";
export const GET_CUSTODIAN_FEES_LEDGER_FAILED = "GET_CUSTODIAN_FEES_LEDGER_FAILED";

export const GET_EXIT_LOAD_LEDGER = "GET_EXIT_LOAD_LEDGER";
export const GET_EXIT_LOAD_LEDGER_RESPONSE = "GET_EXIT_LOAD_LEDGER_RESPONSE";
export const GET_EXIT_LOAD_LEDGER_FAILED = "GET_EXIT_LOAD_LEDGER_FAILED";

export const PMS_MANAGEMENT_FEES_LEDGER = "PMS_MANAGEMENT_FEES_LEDGER";
export const PMS_MANAGEMENT_FEES_LEDGER_RESPONSE = "PMS_MANAGEMENT_FEES_LEDGER_RESPONSE";
export const PMS_MANAGEMENT_FEES_LEDGER_FAILED = "PMS_MANAGEMENT_FEES_LEDGER_FAILED";

export const PMS_UP_FRONT_FEES_PAYABLE_LEDGER = "PMS_UP_FRONT_FEES_PAYABLE_LEDGER";
export const PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE = "PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE";
export const PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED = "PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED";

export const GET_INCOME_EXPENSE_STATEMENT = "GET_INCOME_EXPENSE_STATEMENT";
export const GET_INCOME_EXPENSE_STATEMENT_RESPONSE = "GET_INCOME_EXPENSE_STATEMENT_RESPONSE";
export const GET_INCOME_EXPENSE_STATEMENT_FAILED = "GET_INCOME_EXPENSE_STATEMENT_FAILED";

/*Feespayble*/
export const GET_LEDGER_ACCOUNT = "GET_LEDGER_ACCOUNT";
export const GET_LEDGER_ACCOUNT_RESPONSE = "GET_LEDGER_ACCOUNT_RESPONSE";
export const GET_LEDGER_ACCOUNT_FAILED = "GET_LEDGER_ACCOUNT_FAILED";


/*Movement Of Corpus */
export const PMS_MOVEMENT_OF_CORPUS = "PMS_MOVEMENT_OF_CORPUS";
export const PMS_MOVEMENT_OF_CORPUS_RESPONSE = "PMS_MOVEMENT_OF_CORPUS_RESPONSE";
export const PMS_MOVEMENT_OF_CORPUS_FAILED = "PMS_MOVEMENT_OF_CORPUS_FAILED";

/* 	Performance Based Fees Ledger */
export const PMS_PERFORMANCE_BASED_FEES_LEDGER = "PMS_PERFORMANCE_BASED_FEES_LEDGER";
export const PMS_PERFORMANCE_BASED_FEES_LEDGER_RESPONSE = "PMS_PERFORMANCE_BASED_FEES_LEDGER_RESPONSE";
export const PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED = "PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED";

/*Profit and loss */
export const PMS_PROFIT_LOSS = "PMS_PROFIT_LOSS";
export const PMS_PROFIT_LOSS_RESPONSE = "PMS_PROFIT_LOSS_RESPONSE";
export const PMS_PROFIT_LOSS_FAILED = "PMS_PROFIT_LOSS_FAILED";

/*Securities Transaction Tax Ledger */
export const PMS_SECURITIES_TRANSACTION_TAX = "PMS_SECURITIES_TRANSACTION_TAX";
export const PMS_SECURITIES_TRANSACTION_TAX_RESPONSE = "PMS_SECURITIES_TRANSACTION_TAX_RESPONSE";
export const PMS_SECURITIES_TRANSACTION_TAX_FAILED = "PMS_SECURITIES_TRANSACTION_TAX_FAILED";

/*Transaction Statement
 */
export const PMS_TRANSACTION_STATEMENT_REPORT = "PMS_TRANSACTION_STATEMENT_REPORT";
export const PMS_TRANSACTION_STATEMENT_REPORT_RESPONSE = "PMS_TRANSACTION_STATEMENT_REPORT_RESPONSE";
export const PMS_TRANSACTION_STATEMENT_REPORT_FAILED = "PMS_TRANSACTION_STATEMENT_REPORT_FAILED";

/**
 * performance fees calculation
 */
export const PERFORMANCE_FEES_CALCULATION = "PERFORMANCE_FEES_CALCULATION";
export const PERFORMANCE_FEES_CALCULATION_RESPONSE = "PERFORMANCE_FEES_CALCULATION_RESPONSE";
export const PERFORMANCE_FEES_CALCULATION_FAILED = "PERFORMANCE_FEES_CALCULATION_FAILED";

/*
Welcome letter
*/
export const GET_PMS_WELCOME_LETTER = "GET_PMS_WELCOME_LETTER";
export const GET_PMS_WELCOME_LETTER_RESPONSE = "GET_PMS_WELCOME_LETTER_RESPONSE";
export const GET_PMS_WELCOME_LETTER_FAILED = "GET_PMS_WELCOME_LETTER_FAILED";

export const GET_MIS_MONTH = "GET_MIS_MONTH";
export const GET_MIS_MONTH_RESPONSE = "GET_MIS_MONTH_RESPONSE";
export const GET_MIS_MONTH_FAILED = "GET_MIS_MONTH_FAILED";

export const MIS_REPORTS = "MIS_REPORTS";
export const MIS_REPORTS_RESPONSE = "MIS_REPORTS_RESPONSE";
export const MIS_REPORTS_FAILED = "MIS_REPORTS_FAILED";

export const ACC_PER_MERGER_REPORTS = "ACC_PER_MERGER_REPORTS";
export const ACC_PER_MERGER_REPORTS_RESPONSE = "ACC_PER_MERGER_REPORTS_RESPONSE";
export const ACC_PER_MERGER_REPORTS_FAILED = "ACC_PER_MERGER_REPORTS_FAILED";

export const ONEPAGER_REPORTS = "ONEPAGER_REPORTS";
export const ONEPAGER_REPORTS_RESPONSE = "ONEPAGER_REPORTS_RESPONSE";
export const ONEPAGER_REPORTS_FAILED = "ONEPAGER_REPORTS_FAILED";

export const CAGR_REPORT = "CAGR_REPORT";
export const CAGR_REPORT_RESPONSE = "CAGR_REPORT_RESPONSE";
export const CAGR_REPORT_FAILED = "CAGR_REPORT_FAILED";









